import { Component, OnInit} from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { ActivatedRoute } from '@angular/router';
import { IntlService } from '../../core/services/intl.service';
@Component({
  selector: 'app-client-cancel-booking',
  templateUrl: './client-cancel-booking.component.html',
  styleUrls: ['./client-cancel-booking.component.scss']
})
export class ClientCancelBookingComponent implements OnInit {

  public errorMsg;
  public loading;
  public submitAttempted = false;
  public bookingId;
  public bookingCode;
  public booking;
  public deleted = false;
  formatTime: string;

  constructor(private clientService: ClientService,
    private activatedRoute: ActivatedRoute,
    private intlService: IntlService,
    ) { }

  ngOnInit() {
    this.formatTime = this.intlService.getTimeFormatShort();
    this.bookingId = this.activatedRoute.snapshot.params.bookingId;
    this.bookingCode = this.activatedRoute.snapshot.params.bookingCode;

    this.loading = true;
    this.clientService.getBooking(this.bookingId, this.bookingCode).subscribe(res => {
      this.booking = res;
      this.loading = false;
    }, err => {
      if (err.errMsg === 'Not found Booking') {
        this.deleted = true;
        this.loading = false;
      } else {
        this.errorMsg = err.errMsg;
        this.loading = false;
      }
    });
  }

  cancelBooking() {
    this.loading = true;
    this.submitAttempted = true;
    this.errorMsg = null;

    this.clientService.cancelBooking(this.bookingId, this.bookingCode).subscribe(() => {
      this.loading = false;
      this.deleted = true;
    }, err => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }
}
